//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ExperiencePreviewItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    dateTo () {
      return this.item.to ? this.$moment(this.item.to).format('YYYY') : '-'
    },
    dateFrom () {
      return this.$moment(this.item.from).format('YYYY')
    }
  }
}
